/**
 * Display URLs for listing photos. Full S3 originals are ~100–500KB;
 * card/thumb sizes go through wsrv.nl (edge resize + WebP) so grids load faster.
 */

export type ListingImageSize = 'thumb' | 'card' | 'detail' | 'full';

const WIDTH: Record<Exclude<ListingImageSize, 'full'>, number> = {
  thumb: 200,
  card: 480,
  detail: 1200,
};

export function listingImageUrl(
  url: string | null | undefined,
  size: ListingImageSize = 'card',
): string {
  if (!url) return '';
  const trimmed = url.trim();
  if (!trimmed) return '';
  if (size === 'full') return trimmed;
  if (trimmed.startsWith('data:') || trimmed.startsWith('blob:')) return trimmed;
  if (!/^https?:\/\//i.test(trimmed)) return trimmed;
  if (/wsrv\.nl\//i.test(trimmed) || /images\.weserv\.nl\//i.test(trimmed)) return trimmed;

  const w = WIDTH[size];
  const params = new URLSearchParams({
    url: trimmed,
    w: String(w),
    q: '75',
    output: 'webp',
    we: '',
  });
  return `https://wsrv.nl/?${params.toString()}`;
}
